import { useState } from "react";
import { post, C } from "./utils";

const Msg = ({ type, text }) => (
  <div style={{ padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "1rem", background: type === "error" ? C.errorBg : C.successBg, color: type === "error" ? C.error : C.success, border: `0.5px solid ${type === "error" ? "#F09595" : "#9FE1CB"}` }}>{text}</div>
);

const Field = ({ label, ...p }) => (
  <div style={{ marginBottom: "1rem" }}>
    <label style={{ display: "block", fontSize: "12px", color: C.muted, marginBottom: "5px", fontWeight: "500" }}>{label}</label>
    <input style={{ width: "100%", padding: "10px 14px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, color: C.text, fontSize: "14px", outline: "none", boxSizing: "border-box" }} {...p} />
  </div>
);

const PrimaryBtn = ({ children, loading, ...p }) => (
  <button style={{ width: "100%", padding: "11px", borderRadius: "8px", border: "none", background: C.primary, color: C.white, fontSize: "14px", fontWeight: "500", cursor: "pointer", marginTop: "0.25rem", opacity: loading ? 0.7 : 1 }} {...p}>
    {loading ? "Please wait..." : children}
  </button>
);

const TextBtn = ({ children, ...p }) => (
  <button style={{ background: "none", border: "none", color: C.mid, fontSize: "13px", cursor: "pointer", padding: 0, textDecoration: "underline" }} {...p}>{children}</button>
);

// ─── Project selector ─────────────────────────
function ProjectSelect({ projects, onSelect, onBack, loading, msg }) {
  const [sel, setSel] = useState(null);
  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
      <div style={{ width: "100%", maxWidth: "480px", background: C.white, borderRadius: "16px", border: `1px solid ${C.border}`, padding: "2rem" }}>
        <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
          <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: C.white, fontWeight: "700", fontSize: "20px", margin: "0 auto 1rem" }}>P</div>
          <div style={{ fontSize: "18px", fontWeight: "500", color: C.text }}>Select a project</div>
          <div style={{ fontSize: "13px", color: C.muted, marginTop: "4px" }}>You have access to multiple projects</div>
        </div>
        {msg && <Msg {...msg} />}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "360px", overflowY: "auto" }}>
          {projects.map(p => (
            <button key={p.USERID} onClick={() => { setSel(p); onSelect(p); }} disabled={loading}
              style={{ padding: "14px 16px", borderRadius: "10px", border: `1px solid ${sel?.USERID === p.USERID ? C.primary : C.border}`, background: sel?.USERID === p.USERID ? C.light : C.white, cursor: "pointer", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: "14px", fontWeight: "500", color: C.text }}>{p.PROJECTNAME}</div>
               
              </div>
              <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: C.primary }} />
            </button>
          ))}
        </div>
        <button onClick={onBack} style={{ width: "100%", marginTop: "1rem", padding: "10px", borderRadius: "8px", border: `1px solid ${C.border}`, background: "none", color: C.muted, fontSize: "13px", cursor: "pointer" }}>
          Back to login
        </button>
      </div>
    </div>
  );
}

// ─── Login page ───────────────────────────────
export default function Login({ onAuthenticated }) {
  const [screen, setScreen]     = useState("login");
  const [loginTab, setLoginTab] = useState("email");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile]     = useState("");
  const [otp, setOtp]           = useState("");
  const [otpSent, setOtpSent]   = useState(false);
  const [loading, setLoading]   = useState(false);
  const [msg, setMsg]           = useState(null);
  const [projects, setProjects] = useState(null);

  const reset = () => { setMsg(null); setOtpSent(false); setOtp(""); setProjects(null); };

  const handleLoginResponse = (r) => {
    console.log("Login response:", JSON.stringify(r, null, 2));
    if (r.STATUS !== "1") { setMsg({ type: "error", text: r.MESSAGE }); return; }
    if (r.IS_PROJECTLIST === "true" && Array.isArray(r.DATA)) setProjects(r.DATA);
    else onAuthenticated(r.DATA);
  };

  const handleEmail = async () => {
    setLoading(true); setMsg(null);
    try { handleLoginResponse(await post("login", { mode: "email", email, password, device: "web" })); }
    catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  const handleSendOtp = async () => {
    setLoading(true); setMsg(null);
    try {
      const r = await post("login", { mode: "otp", mobile, device: "web" });
      if (r.STATUS === "1") { setOtpSent(true); setMsg({ type: "success", text: r.MESSAGE }); }
      else setMsg({ type: "error", text: r.MESSAGE });
    } catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  const handleValidate = async () => {
    setLoading(true); setMsg(null);
    try { handleLoginResponse(await post("login", { mode: "validate", mobile, otp, device: "web" })); }
    catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  const handleForgot = async () => {
    setLoading(true); setMsg(null);
    try {
      const r = await post("login", { mode: "forgot", email });
      if (r.STATUS === "1") { setMsg({ type: "success", text: r.MESSAGE }); setTimeout(() => { reset(); setScreen("login"); }, 2000); }
      else setMsg({ type: "error", text: r.MESSAGE });
    } catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  const handleRegister = async () => {
    setLoading(true); setMsg(null);
    try {
      const r = await post("register", { email });
      if (r.STATUS === "1") { setMsg({ type: "success", text: r.MESSAGE }); setTimeout(() => { reset(); setScreen("login"); }, 2000); }
      else setMsg({ type: "error", text: r.MESSAGE });
    } catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  const handleProjectSelect = async (p) => {
    setLoading(true); setMsg(null);
    try {
      const r = await post("login", { mode: "userid", userid: p.USERID, device: "web" }, p.AUTH_CODE);
      if (r.STATUS === "1") onAuthenticated(r.DATA);
      else setMsg({ type: "error", text: r.MESSAGE });
    } catch { setMsg({ type: "error", text: "Connection failed." }); }
    setLoading(false);
  };

  if (projects) return (
    <ProjectSelect projects={projects} onSelect={handleProjectSelect}
      onBack={() => { setProjects(null); setMsg(null); }}
      loading={loading} msg={msg} />
  );

  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
      <div style={{ width: "100%", maxWidth: "420px" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <div style={{ width: "56px", height: "56px", borderRadius: "14px", background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: C.white, fontWeight: "700", fontSize: "24px", margin: "0 auto 1rem" }}>P</div>
          <div style={{ fontSize: "22px", fontWeight: "500", color: C.text }}>PharmaVision</div>
          <div style={{ fontSize: "13px", color: C.muted, marginTop: "4px" }}>Intelligence Platform</div>
        </div>

        <div style={{ background: C.white, borderRadius: "16px", border: `1px solid ${C.border}`, padding: "2rem" }}>

          {screen === "login" && <>
            <div style={{ fontSize: "16px", fontWeight: "500", color: C.text, marginBottom: "1.25rem" }}>Sign in</div>
            <div style={{ display: "flex", background: C.bg, borderRadius: "8px", padding: "3px", marginBottom: "1.25rem" }}>
              {["email", "mobile"].map(t => (
                <button key={t} onClick={() => { setLoginTab(t); setMsg(null); setOtpSent(false); }}
                  style={{ flex: 1, padding: "7px", borderRadius: "6px", border: "none", background: loginTab === t ? C.white : "transparent", color: loginTab === t ? C.primary : C.muted, fontSize: "13px", fontWeight: loginTab === t ? "500" : "400", cursor: "pointer", boxShadow: loginTab === t ? `0 0 0 1px ${C.border}` : "none" }}>
                  {t === "email" ? "Email" : "Mobile"}
                </button>
              ))}
            </div>
            {msg && <Msg {...msg} />}
            {loginTab === "email" && <>
              <Field label="Email address" type="email" placeholder="you@company.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!loading&&handleEmail()} />
              <Field label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!loading&&handleEmail()} />
              <div style={{ textAlign: "right", marginTop: "-8px", marginBottom: "1rem" }}>
                <TextBtn onClick={() => { reset(); setScreen("forgot"); }}>Forgot password?</TextBtn>
              </div>
              <PrimaryBtn onClick={handleEmail} loading={loading}>Sign in</PrimaryBtn>
            </>}
            {loginTab === "mobile" && <>
              <Field label="Mobile number" placeholder="+1234567890" value={mobile} onChange={e => setMobile(e.target.value)} />
              {!otpSent
                ? <PrimaryBtn onClick={handleSendOtp} loading={loading}>Send OTP</PrimaryBtn>
                : <>
                  <Field label="Enter OTP" placeholder="6-digit code" value={otp} onChange={e => setOtp(e.target.value)} maxLength={6} onKeyDown={e=>e.key==="Enter"&&!loading&&handleValidate()} />
                  <PrimaryBtn onClick={handleValidate} loading={loading}>Verify OTP</PrimaryBtn>
                  <div style={{ textAlign: "center", marginTop: "0.75rem" }}><TextBtn onClick={handleSendOtp}>Resend OTP</TextBtn></div>
                </>
              }
            </>}
            <div style={{ textAlign: "center", marginTop: "1.25rem", fontSize: "13px", color: C.muted }}>
              New user? <TextBtn onClick={() => { reset(); setScreen("register"); }}>Register here</TextBtn>
            </div>
          </>}

          {screen === "forgot" && <>
            <div style={{ fontSize: "16px", fontWeight: "500", color: C.text, marginBottom: "4px" }}>Forgot password</div>
            <div style={{ fontSize: "13px", color: C.muted, marginBottom: "1.25rem" }}>We'll send your credentials to your email</div>
            {msg && <Msg {...msg} />}
            <Field label="Email address" type="email" placeholder="you@company.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!loading&&handleForgot()} />
            <div style={{ textAlign: "center", marginTop: "1rem" }}><TextBtn onClick={() => { reset(); setScreen("login"); }}>Back to login</TextBtn></div>
          </>}

          {screen === "register" && <>
            <div style={{ fontSize: "16px", fontWeight: "500", color: C.text, marginBottom: "4px" }}>Create account</div>
            <div style={{ fontSize: "13px", color: C.muted, marginBottom: "1.25rem" }}>Use your company email to register</div>
            {msg && <Msg {...msg} />}
            <Field label="Company email" type="email" placeholder="you@company.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!loading&&handleRegister()} />
            <div style={{ fontSize: "12px", color: C.muted, marginBottom: "1rem" }}>Your domain must be registered. Contact info@medsphere.net for access.</div>
            <PrimaryBtn onClick={handleRegister} loading={loading}>Register</PrimaryBtn>
            <div style={{ textAlign: "center", marginTop: "1rem" }}><TextBtn onClick={() => { reset(); setScreen("login"); }}>Back to login</TextBtn></div>
          </>}

        </div>
        <div style={{ textAlign: "center", marginTop: "1.5rem", fontSize: "12px", color: C.hint }}>
          PharmaVision © 2026 · <a href="http://www.medsphere.net/" target="_blank" rel="noopener noreferrer" style={{ color: C.hint, textDecoration: "none", borderBottom: "1px solid currentColor" }}>MedSphere</a>®
        </div>
      </div>
    </div>
  );
}